const cpAuth = {
	AUTH_USER_TOKEN: "cp_tk",
};

export default cpAuth;
